import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchContentViewPlansInCurrentBoard() {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  yield put(actions.fetchContentViewPlans(pointSystem.id));

  let body;
  try {
    body = yield call(request, api.getContentViewPlans, pointSystem.id);
  } catch (error) {
    yield put(actions.fetchContentViewPlans.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.fetchContentViewPlans.success(pointSystem.id, body.items));
}

export function* getOrCreateContentViewPlanInCurrentBoard(year, month) {
  const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
  if (!pointSystem) {
    return;
  }

  const data = { year, month };

  yield put(actions.getOrCreateContentViewPlan(pointSystem.id, data));

  let item;
  try {
    ({ item } = yield call(request, api.getOrCreateContentViewPlan, pointSystem.id, data));
  } catch (error) {
    yield put(actions.getOrCreateContentViewPlan.failure(pointSystem.id, error));
    return;
  }

  yield put(actions.getOrCreateContentViewPlan.success(item));
}

export function* updateContentViewPlan(id, data) {
  yield put(actions.updateContentViewPlan(id, data));

  let item;
  try {
    ({ item } = yield call(request, api.updateContentViewPlan, id, data));
  } catch (error) {
    yield put(actions.updateContentViewPlan.failure(id, error));
    return;
  }

  yield put(actions.updateContentViewPlan.success(item));
}

export default {
  fetchContentViewPlansInCurrentBoard,
  getOrCreateContentViewPlanInCurrentBoard,
  updateContentViewPlan,
};

